import React from "react";

import Products from "../components/Products/Products";
import Statistiques from "../components/Statistiques";

export default function AdminDashboard() {
  return (
    <div
      style={{
        padding: "2rem",
        fontFamily: "'Inter', sans-serif",
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      <h1
        style={{
          fontSize: "1.75rem",
          marginBottom: "1.5rem",
          fontWeight: "700",
        }}
      >
        Tableau de bord – Administration
      </h1>

      {/* Statistiques */}
      <Statistiques />

      {/* Liste complète des produits */}
      <div style={{ marginTop: "3rem" }}>
        <h2
          style={{
            fontSize: "1.25rem",
            fontWeight: "600",
            marginBottom: "1rem",
          }}
        >
          Tous les produits
        </h2>
        <div
          style={{
            background: "white",
            padding: "1.5rem",
            borderRadius: "10px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
          }}
        >
          <Products />
        </div>
      </div>
    </div>
  );
}
